// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';

import style from '../Filter.scss';
import inputStyle from '../../../assets/styles/input.scss';
import icons from '../../../assets/styles/icons.scss';

import type { FilterTextType } from '../Filter';

type Props = {
  +filterField: FilterTextType;
};

export default class TextType extends Component<Props> {
  render() {
    const { filterField } = this.props;
    return (
      <article className={classNames(style.filterFieldWrap, style.textFieldWrap)}>
        {filterField.titleIntl && <FormattedMessage id={filterField.titleIntl}>{
          txt => <h2 className={classNames(style.filterTitle, { [style.open]: filterField.isOpen })}
                     onClick={filterField.handleOpen}>{txt}
            <i className={classNames(style.caret,
              { [icons.iconMinusLight]: filterField.isOpen },
              { [icons.iconPlusLight]: !filterField.isOpen })}/>
          </h2>
        }</FormattedMessage>}
        {filterField.isOpen && [
          <FormattedMessage key="textInput"
                            id={filterField.placeholderIntl}>{
            txt => (<input type="text"
                           name={filterField.name}
                           value={filterField.stateValue ? filterField.stateValue.value : ''}
                           onChange={filterField.handler}
                           className={classNames(inputStyle.input,
                             { [style.textFieldInputIcon]: true })}
                           placeholder={txt}/>)
          }</FormattedMessage>,
          filterField.icon &&
          <i key="rightIcon"
             className={classNames(filterField.icon, style.rightIcon)}/>
        ]}
      </article>
    );
  }
}

TextType.propTypes = {
  filterField: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/elements/Filter/TextType/TextType.jsx